import _ from 'es-toolkit/compat';

import type { Nullable } from '@clearverify/types';

export type HeadingValidationRule =
  | Nullable<string>
  | { or: HeadingValidationRule[]; and?: never }
  | { and: HeadingValidationRule[]; or?: never };

export const validateHeadings = (
  headings: Nullable<string>[],
  headingValidationRules: HeadingValidationRule[],
) => {
  return headingValidationRules.every(validateHeading(headings));
};

const validateHeading = (headings: Nullable<string>[]) => (rule: HeadingValidationRule) => {
  if (_.isString(rule)) {
    return headings.includes(rule);
  }

  if (_.isObject(rule)) {
    if (rule.and) {
      return rule.and.every(validateHeading(headings));
    }
    return rule.or.some(validateHeading(headings));
  }

  return false;
};
